/* ==========================================================================
   ZELICAT THEME — before-after.js
   Before / after comparison: the (invisible) range input drives the --pos custom property.
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;
  const { $, $$ } = ZC;

  ZC.mount((root) => {
    $$('[data-ba]', root).forEach((box) => {
      if (!ZC.once(box, 'ba')) return;
      const range = $('[data-ba-range]', box);
      if (!range) return;
      const set = () => box.style.setProperty('--pos', `${range.value}%`);
      range.addEventListener('input', set);
      set();
    });
  });
})();
